function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState as o, useRef as f, useEffect as l } from "react";

var d = function d(_ref) {
  var t = _ref.inputRef,
      s = _ref.value,
      _ref$isAutosize = _ref.isAutosize,
      c = _ref$isAutosize === void 0 ? !1 : _ref$isAutosize,
      _ref$minHeight = _ref.minHeight,
      i = _ref$minHeight === void 0 ? 0 : _ref$minHeight;

  var _o = o(NaN),
      _o2 = _slicedToArray(_o, 2),
      n = _o2[0],
      u = _o2[1],
      _o3 = o(NaN),
      _o4 = _slicedToArray(_o3, 2),
      h = _o4[0],
      N = _o4[1],
      _o5 = o(NaN),
      _o6 = _slicedToArray(_o5, 2),
      r = _o6[0],
      a = _o6[1],
      e = f(null);

  return l(function () {
    t.current && !n && (u(t.current.offsetWidth), N(t.current.scrollHeight));
  }, [t.current]), l(function () {
    t.current && e.current && c && a(Math.max(e.current.offsetHeight > i ? e.current.offsetHeight + parseFloat(window.getComputedStyle(t.current, null).getPropertyValue("font-size")) : i, h)), !Number.isNaN(r) && !c && a(NaN);
  }, [s, t.current, r]), {
    hiddenSpanRef: e,
    initialWidth: n,
    autoHeight: r
  };
};

export { d as useAutoSize };